import {ApiClientService} from '@dofleini/security';
import {SPACE_KEY} from '@/contexts/SessionControlContext';

export default () => {
  const space = window.localStorage.getItem(SPACE_KEY);

  space && ApiClientService.setSpace(space);
}
